import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";

const initialState = (() => {
  const token = Cookies.get("token");
  if (token) {
    const decoded = jwtDecode(token);
    return {
      token,
      user: decoded.user || null, 
      role: decoded.role || null,
    };
  }
  return {
    token: null,
    user: null,
    role: null,
  };
})();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthState: (state, action) => {
      const { user, role, token } = action.payload;
      state.token = token;
      state.user = user;
      state.role = role;
    },
    clearAuthState: (state) => {
      Cookies.remove("token");
      state.user = null;
      state.role = null;
      state.token = null;
    },
  },
});

export const { setAuthState, clearAuthState } = authSlice.actions;
export default authSlice.reducer;
